import App from './app';
import React from 'react';
import ReactDOM from 'react-dom';

ReactDOM.render(<App/>, document.querySelector('#root'));